import { useEffect, useState, RefObject } from 'react';

export function useStickyTopElement(ref: RefObject<HTMLElement>) {
  const [isUnStickTop, setIsUnStickTop] = useState(true);
  const [topPosition, setTopPosition] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    setTopPosition(el.getBoundingClientRect().top);
    const updatePosition = () => {
      const top = el.getBoundingClientRect().top;
      setTopPosition(top);
      setIsUnStickTop(top > 0);
    };

    const handleScroll = () => {
      requestAnimationFrame(updatePosition);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [ref]);

  return { isUnStickTop, topPosition };
}
